import React, { useState } from 'react'
import LiveModal from 'live/components/ui/Modal'
import { Modal } from 'react-bootstrap'
import FormGroup from 'live/components/forms/ui/form-group'
import Label from 'live/components/forms/ui/label'
import ActionToggle from 'live/components/ui/action-toggle'
import styled from 'styled-components'
import Select from 'live/components/forms/ui/select'
import { Layer, Layers } from '../app'
import { DivShowTabs } from '../config'

import MultipleSelection from './MultipleSelection'
import Dropdown from './Dropdown'

const MAX_LAYER = 10

interface Props {
    title: string
    showModal: boolean
    onChangeConfig(layers: Layers): void
    hide(): void
    layers: Layers
    redux: { layers: Layers }
}

function ConfigModal({ title = 'Option', showModal, layers = {}, onChangeConfig, hide, redux }: Props) {
    const [state, setState] = useState(layers)

    const addLayers = () => {
        const id = Object.keys(state).length
        if (id <= MAX_LAYER) {
            setState({
                ...state,
                [id]: {
                    columns: [],
                    name: `Layer ${id + 1}`,
                    rows: [],
                    values: [],
                    showTotal: true
                }
            })
        }
    }
    const removeLayer = () => {
        const keys = Object.keys(state)
        const id = keys.length - 1

        if (id > -1) {
            const newState = { ...state }
            delete newState[id]
            setState(newState)
        }
        // setState({} as Layers);
    }

    const handleSave = () => {
        onChangeConfig(state)
        hide()
    }
    const handleCancel = () => {
        setState(layers)
        hide()
    }

    return (
        <LiveModal
            show={showModal}
            className="modal-lg"
            animation={false}
            backdrop="static"
            draggable={true}
            hide={hide}
        >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DivLayers>
                    {Object.keys(state).map(e => {
                        const layerEvent =
                            redux.layers[e] ||
                            ({
                                columns: [],
                                rows: [],
                                name: `Layer ${e}`,
                                values: [],
                                showTotal: false
                            } as Layer)

                        const layerEventRows = layerEvent.rows || []
                        const layerEventColumns = layerEvent.columns || []
                        const layerEventValues = layerEvent.values || []
                        const options = [
                            ...new Set([...layerEventRows, ...layerEventColumns, ...layerEventValues])
                        ] as string[]

                        const LayerConfig = state[e] as Layer

                        const LayerColumns = LayerConfig.columns as string[]
                        const LayerRows = LayerConfig.rows as string[]
                        const LayerValues = LayerConfig.values as string[]
                        const LayerShowTotal = LayerConfig.showTotal as boolean

                        return (
                            <Dropdown
                                width="100%"
                                label={`Layer ${parseInt(e) + 1}`}
                                render={() => (
                                    <div>
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {'Tab name'} <span className="regular">{'(optional)'}</span>:
                                                </span>
                                            }
                                            name="tabName"
                                            placeholder={`Layer ${parseInt(e) + 1}`}
                                            value={state[e]?.['name']}
                                            onChange={el => {
                                                const updateLayer = state[e] as Layer
                                                updateLayer.name = el.target.value
                                                setState({
                                                    ...state,
                                                    [e]: updateLayer
                                                })
                                            }}
                                        />
                                        <DivShowTabs>
                                            <ActionToggle
                                                onChange={() => {
                                                    const updateLayer = state[e] as Layer
                                                    updateLayer.showTotal = !updateLayer.showTotal
                                                    setState({ ...state, [e]: updateLayer })
                                                }}
                                                active={LayerShowTotal}
                                            />
                                            {`Show Total`}
                                        </DivShowTabs>
                                        <label>Columns</label>
                                        <MultipleSelection
                                            value={LayerColumns}
                                            onChange={values => {
                                                const updateLayer = state[e] as Layer
                                                if (values) {
                                                    updateLayer.columns = values.map(({ value }) => value as string)
                                                }
                                                setState({
                                                    ...state,
                                                    [e]: updateLayer
                                                })
                                            }}
                                            options={options}
                                        />
                                        <label>Rows</label>
                                        <MultipleSelection
                                            value={LayerRows}
                                            onChange={values => {
                                                const updateLayer = state[e] as Layer
                                                if (values) {
                                                    updateLayer.rows = values.map(({ value }) => value as string)
                                                }
                                                setState({
                                                    ...state,
                                                    [e]: updateLayer
                                                })
                                            }}
                                            options={options}
                                        />
                                        <label>Values</label>
                                        <MultipleSelection
                                            value={LayerValues}
                                            onChange={values => {
                                                const updateLayer = state[e] as Layer
                                                if (values) {
                                                    updateLayer.values = values.map(({ value }) => value as string)
                                                }
                                                setState({
                                                    ...state,
                                                    [e]: updateLayer
                                                })
                                            }}
                                            options={options}
                                        />
                                    </div>
                                )}
                            />
                        )
                    })}
                </DivLayers>
                <button
                    className="btn btn-primary"
                    disabled={MAX_LAYER < Object.keys(state).length}
                    onClick={addLayers}
                >
                    add layer
                </button>
                <button className="btn btn-danger" disabled={Object.keys(state).length < -1} onClick={removeLayer}>
                    remove layer
                </button>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" disabled={false} onClick={handleSave}>
                    {'ok'}
                </button>

                <span>{'or'}</span>

                <a onClick={handleCancel}>{'cancel'}</a>
            </Modal.Footer>
        </LiveModal>
    )
}

export default ConfigModal

const GroupedLabelsInputs = styled.div`
    .Select {
        width: 100%;
    }
    width: 100%;
    margin-bottom: 25px;
`

const DivLayers = styled.div`
    display: flex;
    flex-direction: column;
`
